"use client";
import InputSearch from "@onair/ui/form-controls/input-search";
import { cn } from "@onair/utils/cn";
import { memo } from "react";
import { useCourseFilter } from "../store";

export interface EDocInputSearchProps {
	className?: string;
}
const EDocInputSearch: React.FC<EDocInputSearchProps> = ({}) => {
	const { q = "", setSearchText } = useCourseFilter((state) => ({
		q: state.q,
		setSearchText: state.setSearchText,
	}));
	const handleSearch = (value: string) => {
		setSearchText(value);
	};
	return (
		<div className={cn("courses-filter")}>
			<div className="search-form max-w-[480px] mx-auto">
				<InputSearch value={q} onSearch={handleSearch} />
			</div>
		</div>
	);
};
export default memo(EDocInputSearch);
